<div class="vehicle-license" *transloco="let t">
	<form [formGroup]="formGroup" (ngSubmit)="onSubmit()">
		<div class="plate-state op-mt-20">
			<mat-form-field class="form-element" appearance="outline">
				<mat-label>{{ t('VEHICLE.licensePlate') }}</mat-label>
				<input matInput type="text" name="license" id="licensePlate" formControlName="plate" aria-required="true" />
			</mat-form-field>
			<mat-form-field class="form-element" appearance="outline">
				<mat-label>{{ t('VEHICLE.state') }}</mat-label>
				<mat-select formControlName="state" name="state" #state aria-label="state" aria-required="true">
					<mat-option
						*ngFor="let state of stateList$ | async; let i = index"
						id="{{ state.key }}"
						[value]="state.key"
						>{{ state.text }}</mat-option
					>
				</mat-select>
			</mat-form-field>
		</div>

		<div *ngIf="notFound" class="vehicle-invalid op-mt-20">
			<div class="op-mt-10">
				<div class="vehicle-invalid-details">
					<mat-icon svgIcon="op-attention"></mat-icon>
					<div class="op-ml-5 op-black-bold">{{ t('VEHICLE.notFound') }}</div>
				</div>
			</div>
			<div class="op-mt-10">
				<div class="vehicle-invalid-details">
					<div class="op-ml-10 vehicle-invalid-another">
						<div>{{ t('VEHICLE.differentWay') }}</div>
						<div class="vehicle-invalid-try-now">
							<div class="op-black-bold">
								<a href="" onclick="return false" class="" id="tryNow" (click)="reloadPage()">
									{{ t('VEHICLE.tryNow') }}
								</a>
							</div>
							<mat-icon svgIcon="op-caretRightSmall"></mat-icon>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="op-center op-mt-20" *ngIf="!submitted">
			<button
				mat-flat-button
				color="primary"
				type="submit"
				[opTagClick]="'plate search'"
				[disabled]="formGroup.invalid"
			>
				{{ t('VEHICLE.search') }}
			</button>
		</div>
	</form>
</div>
